import {View} from 'react-native'

import {atoms as a, useTheme, type ViewStyleProp} from '#/alf'
import {useSemanticTokens} from '#/wsocial/service/design-system'

export function Divider({style}: ViewStyleProp) {
  const t = useTheme()
  const s = useSemanticTokens()
  return (
    <View
      style={[
        a.w_full,
        a.border_t,
        {borderColor: s.border.contrast_low},
        style,
      ]}
    />
  )
}
